module.exports = __webpack_public_path__ + "gn.3e48eef83c9efcca2080.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gn.svg
// module chunks = styles